import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { SectionHeading } from "../motion/SectionHeading";
import { Stagger, StaggerItem } from "../motion/Reveal";
import { ProjectCard } from "../cards/ProjectCard";

export const FeaturedProjects = ({ projects = [] }) => {
  const { t } = useLang();
  const featured = projects.filter((p) => p.featured).slice(0, 3);
  const list = featured.length ? featured : projects.slice(0, 3);

  return (
    <section className="py-10 sm:py-14 bg-lightgray" data-testid="featured-projects-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading title={t.projects.title} />
          <Link to="/projects" data-testid="view-all-projects" className="group inline-flex items-center gap-2 text-green font-semibold shrink-0 link-underline">
            {t.projects.allProjects}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        <Stagger className="grid grid-cols-2 lg:grid-cols-3 gap-0 mt-6 sm:mt-10">
          {list.map((p, i) => (
            <StaggerItem key={p.id || p.slug}>
              <ProjectCard project={p} index={i} />
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
